import React from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { ROLES } from "../../constants";

const navItems = [
  { path: "/dashboard", icon: "dashboard", label: "Home", roles: [] },
  { path: "/diem-danh", icon: "fact_check", label: "Điểm danh", roles: [ROLES.GVCN, ROLES.GV_PHU] },
  { path: "/quan-ly-hoc-sinh", icon: "group", label: "Học sinh", roles: [ROLES.ADMIN, ROLES.TRUONG_NGANH, ROLES.GVCN, ROLES.GV_PHU] },
  { path: "/bao-cao", icon: "monitoring", label: "Báo cáo", roles: [ROLES.ADMIN, ROLES.TRUONG_NGANH] },
];

const BottomNav = () => {
  const { hasRole } = useAuthContext();
  const location = useLocation();
  const filtered = navItems.filter(i => i.roles.length === 0 || i.roles.some(r => hasRole(r))).slice(0, 4);

  const handleClick = (e, path) => {
    e.preventDefault();
    if (window.__safeNavigate) {
      window.__safeNavigate(path);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-surface-container-lowest border-t border-outline-variant flex justify-around items-center py-2 px-1 z-[80] shadow-[0_-2px_12px_rgba(0,0,0,0.06)]">
      {filtered.map(item => {
        const active = isActive(item.path);
        return (
          <a
            key={item.path}
            href={item.path}
            onClick={(e) => handleClick(e, item.path)}
            className={`flex flex-col items-center gap-0.5 py-1.5 px-2 rounded-xl no-underline transition-all duration-200 min-w-[64px] active:scale-95
              ${active
                ? 'text-primary font-semibold'
                : 'text-on-surface-variant hover:text-on-surface hover:bg-surface-container'
              }`}
          >
            {active && (
              <div className="w-8 h-0.5 bg-primary rounded-full -mt-0.5 mb-0.5" />
            )}
            <span className={`material-symbols-outlined text-[22px] leading-none`}
              style={active ? { fontVariationSettings: "'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 24" } : {}}
            >
              {item.icon}
            </span>
            <span className="text-[11px] font-medium leading-tight">{item.label}</span>
          </a>
        );
      })}
    </nav>
  );
};

export default BottomNav;